export * from './lifeline.component';
